import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnImage } from "@/components/VnImage";
import { VnText } from "@/components/VnText/VnText";
import { OnboardingScreenType } from "@/domain/onboarding";
import { useOnboardingIntroContent } from "@/hooks/useOnboardingIntroContent";

import { OnboardingStepFrame } from "./OnboardingStepFrame";

export const OnboardingIntroStep: FC<OnboardingScreenType> = layout => {
  const { clinicLogoBase64, title, description } = useOnboardingIntroContent();

  return (
    <OnboardingStepFrame {...layout}>
      <VnBox className="bg-sidebar flex-1 items-center justify-end">
        <VnBox className="bg-background h-[80%] w-full items-center rounded-t-[60] px-10 pt-16">
          <VnBox className="w-full md:max-w-screen-sm">
            {clinicLogoBase64 && (
              <VnBox className="bg-secondary items-center rounded-3xl">
                <VnImage
                  source={clinicLogoBase64}
                  className="h-40 w-full"
                  contentFit="contain"
                />
              </VnBox>
            )}

            <VnBox className="mt-10 gap-3">
              <VnText className="text-start text-xl font-semibold" {...title} />
              <VnText
                className="text-muted-foreground text-start"
                variant="lg"
                {...description}
              />
            </VnBox>
          </VnBox>
        </VnBox>
      </VnBox>
    </OnboardingStepFrame>
  );
};
